import React, { Component } from "react";
import { CardBody, Card, FormText, Label, Form, FormGroup, Row, Col, DropdownItem, Button, Input, DropdownToggle, DropdownMenu, ButtonDropdown } from 'reactstrap'
import Select from 'react-select';
import { toast } from 'react-toastify';


const monthData = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

class CUGDateFilter extends Component {

    state = {
        toSelectOption: undefined, fromSelectOption: undefined, fromOptions: [], toOptions: []
    }

    getMonths = (d2, d1) => {
        let months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += d2.getMonth();
        return months <= 0 ? 0 : months;

    }

    getSelectObject = (month, year, isFrom) => {
        let todayMonth = month;
        let yearString = year.toString();
        if (isFrom) {
            todayMonth = month - 1;
            if (todayMonth < 0) {
                todayMonth = 11;
                year = year - 1;
            }
        }
        return { value: `15-${monthData[todayMonth]}-${year}`, label: `${monthData[month]}-${yearString.substring(2)}` }
    }

    fetchDetailUsingDates = (e) => {
        e.preventDefault();
        let date1 = new Date(this.state.fromSelectOption.value);
        let date2 = new Date(this.state.toSelectOption.value);
        let months = this.getMonths(date2, date1);
        if (date1.getTime() >= date2.getTime()) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Please select <b>Appropriate </b>Period !
                </div>
            );
        } else if (months <= 3) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Please select at least 3 months period !
            </div>)
        } else {
            this.props.fetchDetail(this.state.fromSelectOption.value, this.state.toSelectOption.value, months);
        }

    }
    getFromMonthOptions = () => {
        let today = new Date();
        let fromMonth = [];
        let toMonth = [];
        let todayMonth = today.getMonth();
        let todayYear = today.getFullYear();
        let index;
        let selectFromOptions = {};
        for (index = 0; index < 24; index++) {
            let toObj = this.getSelectObject(todayMonth, todayYear, false);
            todayMonth = todayMonth - 1;
            toMonth.push(toObj);
            if (todayMonth < 0) {
                todayMonth = 11;
                todayYear = todayYear - 1;
            }
            let fromObj = this.getSelectObject(todayMonth, todayYear, true);
            if (index === 14) {
                selectFromOptions = fromObj;
            }
            fromMonth.push(fromObj);
        }
        this.setState({ toSelectOption: toMonth[0], fromSelectOption: selectFromOptions, fromOptions: fromMonth, toOptions: toMonth }, () => {
            console.log(this.state)
        })
    }

    handleFromChange = fromSelectOption => {
        console.log(fromSelectOption);
        this.setState({ fromSelectOption: fromSelectOption })
    }

    handleToChange = toSelectOption => {
        this.setState({ toSelectOption: toSelectOption })
    }

    componentDidMount() {
        this.getFromMonthOptions();
    }

    render() {
        return (<Card className="mt-3 mb-3">
            <CardBody className="rubix-pb-0" >
                <Form className="w-100" >
                    <FormGroup style={{ marginLeft: "1rem" }} row>
                        <Col sm={2} />
                        <Label sm={4}> <h5><b>Report Tenure - </b></h5></Label>
                        <label className="col-form-label">From : </label>
                        <Col sm={4}>
                            <Select
                                options={this.state.fromOptions}
                                value={this.state.fromSelectOption}
                                onChange={this.handleFromChange}
                            />

                        </Col>
                        <label className="col-form-label">To : </label>
                        <Col sm={4}>
                            <Select
                                options={this.state.toOptions}
                                value={this.state.toSelectOption}
                                onChange={this.handleToChange}
                            />

                        </Col>
                        <Col sm={1} />
                        <Button sm={4} color="primary" onClick={(e) => this.fetchDetailUsingDates(e)}> Apply </Button>
                    </FormGroup>

                </Form>
            </CardBody>
        </Card>)
    }
}

export default CUGDateFilter;